import React, { useEffect, useState } from "react";
import FirstNavbar from "../dashboard/FirstNavbar";
import SideBar from "../dashboard/SideBar";
import { AiOutlineUnorderedList } from "react-icons/ai";
import { Link } from "react-router-dom";
import axios from "axios";
import baseURL from "../../Services/Url";
import { Modal, Button, Row, Form, Col, Spinner } from "react-bootstrap";
import { ToastContainer, toast, Zoom } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import MyStatefulEditor from "../Components/RichText";
import { AgGridReact } from "ag-grid-react";

function Property_enquiry() {
  const [ProductList, setPoductList] = useState([]);
  const [reloadPage, setReloadPage] = useState(1);
  const [loader, setLoader] = useState(false);
  const [rowData, setRowdata] = useState();

  const [updateMemberForm, setupdateMemberForm] = useState({
    name: "",
    email: "",
    image: "",
  });

  const [formInterData, setFormInterData] = useState();
  useEffect(() => {
    const one1 = [updateMemberForm.Applicants].map((ele, ind) => {
      setFormInterData(ele, "eleeleeleele ====>");
    });
  });

  const [file, setFile] = useState({
    image: "",
  });
  const [fileErrors, setFileErrors] = useState({
    image: "",
  });

  const [updateMemberFormErrors, setupdateMemberFormErrors] = useState({});

  useEffect(() => {
    productsListApi();
  }, [reloadPage]);

  /** Product List **/
  const productsListApi = async () => {
    try {
      const res = await axios.get(`${baseURL}/property_enquiry_list`);
      if (res.status === 200 || res.status === 201) {
        let enquiries = res.data;
        if (Array.isArray(enquiries)) {
          // keep as is
        } else if (enquiries.data && Array.isArray(enquiries.data)) {
          enquiries = enquiries.data;
        } else {
          enquiries = [];
        }
        enquiries.sort(
          (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
        );

        try {
          const [propertiesRes, projectsRes] = await Promise.all([
            axios.get(`${baseURL}/category/properties`).catch(() => ({ data: [] })),
            axios.get(`${baseURL}/projects`).catch(() => ({ data: [] }))
          ]);
          
          const extractData = (response) => {
            const data = response?.data?.data || response?.data?.items || response?.data?.docs || response?.data || [];
            return Array.isArray(data) ? data : [];
          };

          const properties = [...extractData(propertiesRes), ...extractData(projectsRes)];
          
          enquiries = enquiries.map(enq => {
             const property = properties.find(p => p.property_id === enq.property_id || p.id === enq.property_id || p._id === enq.property_id || p.slug === enq.property_id);
             return {
                ...enq,
                property_title: property ? property.title : (enq.property_id || "N/A"),
             }
          });
        } catch (e) {
          console.error("Error fetching properties to map titles", e);
        }

        setRowdata(enquiries);
      }
    } catch (err) {
      console.log(err, "err");
    }
  };

  /* list */
  const [deleleId, setDelelete] = useState("");
  const handleDelete = (ele) => {
    setShowDelete(true);
    setDelelete(ele);
  };

  const [showDelete, setShowDelete] = useState(false);
  const handleDeleteClose = () => {
    setShowDelete(false);
  };

  const handleDeleteClear = () => {
    setShowDelete(false);
  };

  const handleDeleteSubmit = () => {
    setLoader(true);
    axios
      .delete(`${baseURL}/${deleleId.id}`, {
        // headers: {
        //   Authorization: `Bearer ${token}`
        // },
      })
      .then((res) => {
        if (res.status == 200) {
          toast.success("Successfully Deleted");
          setLoader(false);
          setReloadPage(reloadPage + 1);
          setShowDelete(false);
        }
      })
      .catch((err) => {
        if (err.response.status == 401) {
          toast.error("Token is Expaired");
          setLoader(false);
          setReloadPage(reloadPage + 1);
          setShowDelete(false);
        }
      });
  };

  const handleClose = () => {
    setShow(false);
  };

  /* update */
  const [updateID, setUpdateId] = useState("");
  const [show, setShow] = useState(false);

  /** handle Change **/
  const handleChange = (event) => {
    if (event.target.name == "image") {
      setFile({
        ...file,
        [event.target.name]: event?.target?.files[0],
      });
      setFileErrors({
        ...file,
        image: "",
      });
    } else {
      setupdateMemberForm({
        ...updateMemberForm,
        [event.target.name]: event.target.value,
      });
    }
    setupdateMemberFormErrors({
      ...updateMemberFormErrors,
      [event.target.name]: null,
    });
  };

  const handleUpdate = (ele) => {
    setShow(true);
    setupdateMemberForm({
      ...updateMemberForm,
      heading: ele.name,
      text: ele.email,
      contact_no: ele.contact_no,
      description: ele.description,
      createdAt: ele.createdAt,
      property_id: ele.property_id,
      property_title: ele.property_title,
    });
    setShow(true);
    setUpdateId(ele);
  };

  const handleSubmit = () => {
    setLoader(true);
    let formData = new FormData();
    formData.append("category", "enquiry");

    if (updateMemberForm.heading) {
      formData.append("title", updateMemberForm.heading);
    }

    if (updateMemberForm.text) {
      formData.append("description", updateMemberForm.text);
    }

    if (file.image) {
      formData.append("image", file.image);
    }

    // const token = '32c2483430c53f2eec280c7f1ba826f697e78ac7'
    // headers: {
    //   Authorization: `Bearer ${token}`
    // },
    axios({
      url: `${baseURL}/${updateID.id}`,
      method: "PUT",
      data: formData,
    })
      .then((res) => {
        if (res.status == 200) {
          setReloadPage(reloadPage + 1);
          setShow(false);
          toast.success("Successfully Updated Meamber");
          setLoader(false);
          setupdateMemberForm({
            ...updateMemberForm,
            name: "",
            surname: "",
            disignation: "",
          });
          setFile({
            ...file,
            image: "",
          });
          setFileErrors({
            ...fileErrors,
            image: "",
          });
        }
      })
      .catch((err) => {
        if (err.response.status == 401) {
          setReloadPage(reloadPage + 1);
          setShow(false);
          toast.error("Token is Expaired");
          setLoader(false);
          setupdateMemberForm({
            ...updateMemberForm,
            name: "",
            surname: "",
            disignation: "",
          });
          setFile({
            ...file,
            image: "",
          });
          setFileErrors({
            ...fileErrors,
            image: "",
          });
        }
      });
    // }
  };

  const handleClear = () => {
    setupdateMemberForm({
      ...updateMemberForm,
      heading: "",
      text: "",
      image: "",
    });
    setFile({
      ...file,
      image: "",
    });
    setFileErrors({
      ...fileErrors,
      image: "",
    });
  };
  const handleData = (value) => {
    // setRichTextdata(value)
    setupdateMemberForm({
      ...updateMemberForm,
      ["text"]: value,
    });
    setupdateMemberFormErrors({
      ...updateMemberFormErrors,
      ["text"]: null,
    });
  };

  /***** Pagenation Table******/
  const rowHeight = 50;
  const DefaultColumnSetting = {
    sortable: true,
    filter: true,
    floatingFilter: true,
    flex: 1,
    resizable: true,
    minWidth: 120,
  };

  const [colDefs, setColDefs] = useState([
    {
      headerName: "Id",
      valueGetter: "node.rowIndex + 1",
      filter: true,
      lockPosition: true,
    },
    {
      headerName: "Name",
      filter: true,
      field: "name",
    },
    {
      headerName: "Email",
      filter: true,
      field: "email",
    },
    {
      headerName: "Mobile Number",
      filter: true,
      field: "contact_no",
    },
    {
      headerName: "Description",
      filter: true,
      field: "description",
    },
    {
      headerName: "Date & Time",
      filter: true,
      minWidth: 200,
      valueGetter: (params) => {
        if (!params.data.createdAt) return "";
        return new Date(params.data.createdAt).toLocaleString();
      },
    },
    {
      headerName: "Property Title",
      filter: true,
      field: "property_title",
    },
    {
      headerName: "Property ID",
      filter: true,
      field: "property_id",
    },
    {
      headerName: "Action",
      filter: false,
      cellRendererFramework: (params) => (
        <div onClick={() => handleUpdate(params.data)} style={{ cursor: 'pointer' }}>
          <button type="button" class="btn btn-outline-primary">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="16"
              height="16"
              fill="currentColor"
              class="bi bi-eye"
              viewBox="0 0 16 16"
            >
              <path d="M16 8s-3-5.5-8-5.5S0 8 0 8s3 5.5 8 5.5S16 8 16 8zM1.173 8a13.133 13.133 0 0 1 1.66-2.043C4.12 4.668 5.88 3.5 8 3.5c2.12 0 3.879 1.168 5.168 2.457A13.133 13.133 0 0 1 14.828 8c-.058.087-.122.183-.195.288-.335.48-.83 1.12-1.465 1.755C11.879 11.332 10.119 12.5 8 12.5c-2.12 0-3.879-1.168-5.168-2.457A13.134 13.134 0 0 1 1.172 8z" />
              <path d="M8 5.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5zM4.5 8a3.5 3.5 0 1 1 7 0 3.5 3.5 0 0 1-7 0z" />
            </svg>
          </button>
        </div>
      ),
    },
  ]);

  console.log(rowData, "apply ===>");

  const pdfDownlod = async (e) => {
    console.log(e.target);
  };

  return (
    <div>
      <ToastContainer
        position="top-center"
        autoClose={1000}
        hideProgressBar
        transition={Zoom}
        delay={500}
        limit={1}
      />
      <Modal show={showDelete} onHide={handleDeleteClose}>
        <Modal.Header closeButton>
          <Modal.Title>Delete Career</Modal.Title>
        </Modal.Header>
        <Modal.Footer>
          <Modal.Body>
            <div className="d-flex">
              <div style={{ marginLeft: "50px" }}>
                <Button variant="secondary" onClick={handleDeleteClear}>
                  Cancel
                </Button>
              </div>
              <div style={{ marginLeft: "150px" }}>
                {loader == false && (
                  <Button variant="danger" onClick={handleDeleteSubmit}>
                    Delete
                  </Button>
                )}
                {loader == true && (
                  <Spinner animation="border" variant="Primary" />
                )}
              </div>
            </div>
          </Modal.Body>
        </Modal.Footer>
      </Modal>
      <Modal
        show={show}
        onHide={handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>All Details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-md-12">
              <div className="row">
                <div className="col-md-6">
                  <p><b>Date :-</b></p>
                  <p>{updateMemberForm?.createdAt ? new Date(updateMemberForm.createdAt).toLocaleString() : ""}</p>
                  <p><b>Property Title :-</b></p>
                  <p>{updateMemberForm?.property_title}</p>
                  <p><b>Property ID :-</b></p>
                  <p>{updateMemberForm?.property_id}</p>
                  <p><b>Name :-</b></p>
                  <p>{updateMemberForm?.heading}</p>
                </div>
                <div className="col-md-6">
                  <p><b>Email :-</b></p>
                  <p>{updateMemberForm?.text}</p>
                  <p><b>Contact Number :-</b></p>
                  <p>{updateMemberForm?.contact_no}</p>
                  <p><b>Description :-</b></p>
                  <p>{updateMemberForm?.description}</p>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      <div>
        <div class="sidebar">
          <SideBar />
        </div>

        <div class="content">
          <div className="container ">
            <FirstNavbar />

            <div className="row my-2">
              <div className="col-md-4">
                <h3>
                  <b>Properties Enquiry List</b>
                </h3>
              </div>

              <div className="col-md-8 text-end">
                <button type="button" className="btn btn-outline-success mx-1">
                  <Link to="/properties-add">Add Properties </Link>
                </button>
                <button type="button" className="btn btn-outline-success mx-1">
                  <Link to="/properties-list"> Properties List</Link>
                </button>
                <button
                  type="button"
                  className="btn btn-outline-success mx-1"
                  disabled
                >
                  <Link to="/Property_enquiry">Property Enquiry</Link>
                </button>
                {/* <button type="button" className="btn btn-outline-success mx-1">
                  <Link to="/internform">Intern With Us List</Link>
                </button>
                <button type="button" className="btn btn-outline-success mx-1">
                  <Link to="/anyoneform">Anyone Can Apply List</Link>
                </button> */}
              </div>
            </div>

            <div
              className="ag-theme-alpine"
              style={{ height: "75vh", width: "100%" }}
            >
              <AgGridReact
                rowHeight={rowHeight}
                // columnDefs={columns}
                columnDefs={colDefs}
                defaultColDef={DefaultColumnSetting}
                pagination={true}
                paginationPageSize={20}
                // onGridReady={onGridReady}
                rowData={rowData}
              />{" "}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}


export default Property_enquiry;